module.exports = __webpack_public_path__ + "media/theme/3 open-54314fe5.png";